import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
  totals: { total: 0, gst: 0 },
  totalItems: 0,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.cartItems = action.payload;
      state.totalItems = action.payload.reduce((sum, item) => sum + (item.quantity || 0), 0);
      state.totals = action.payload.reduce(
        (acc, item) => {
          const price = parseFloat(item.base_price || 0);
          const gstRate = parseFloat(item.tax_rate || 0);
          const gstAmtPerItem = (price * gstRate) / 100;
          const totalPerItem = price + gstAmtPerItem;
          acc.gst += gstAmtPerItem * (item.quantity || 0);
          acc.total += totalPerItem * (item.quantity || 0);
          return acc;
        },
        { total: 0, gst: 0 }
      );
      localStorage.setItem('selectedProducts', JSON.stringify(state.cartItems));
    },
    addToCart: (state, action) => {
      const product = action.payload;
      const exist = state.cartItems.find((i) => i.id === product.id);
      let updated;
      if (exist) {
        updated = state.cartItems.map((i) =>
          i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      } else {
        updated = [...state.cartItems, { ...product, quantity: 1 }];
      }
      state.cartItems = updated;
      state.totalItems = updated.reduce((sum, item) => sum + (item.quantity || 0), 0);
      state.totals = updated.reduce(
        (acc, item) => {
          const price = parseFloat(item.base_price || 0);
          const gstRate = parseFloat(item.tax_rate || 0);
          const gstAmtPerItem = (price * gstRate) / 100;
          const totalPerItem = price + gstAmtPerItem;
          acc.gst += gstAmtPerItem * (item.quantity || 0);
          acc.total += totalPerItem * (item.quantity || 0);
          return acc;
        },
        { total: 0, gst: 0 }
      );
      localStorage.setItem('selectedProducts', JSON.stringify(updated));
    },
    updateQuantity: (state, action) => {
      const { id, change } = action.payload;
      const updated = state.cartItems
        .map((i) =>
          i.id === id ? { ...i, quantity: Math.max(1, i.quantity + change) } : i
        )
        .filter((i) => i.quantity > 0);
      state.cartItems = updated;
      state.totalItems = updated.reduce((sum, item) => sum + (item.quantity || 0), 0);
      state.totals = updated.reduce(
        (acc, item) => {
          const price = parseFloat(item.base_price || 0);
          const gstRate = parseFloat(item.tax_rate || 0);
          const gstAmtPerItem = (price * gstRate) / 100;
          const totalPerItem = price + gstAmtPerItem;
          acc.gst += gstAmtPerItem * (item.quantity || 0);
          acc.total += totalPerItem * (item.quantity || 0);
          return acc;
        },
        { total: 0, gst: 0 }
      );
      localStorage.setItem('selectedProducts', JSON.stringify(updated));
    },
    removeItem: (state, action) => {
      const updated = state.cartItems.filter((item) => item.id !== action.payload);
      state.cartItems = updated;
      state.totalItems = updated.reduce((sum, item) => sum + (item.quantity || 0), 0);
      state.totals = updated.reduce(
        (acc, item) => {
          const price = parseFloat(item.base_price || 0);
          const gstRate = parseFloat(item.tax_rate || 0);
          const gstAmtPerItem = (price * gstRate) / 100;
          const totalPerItem = price + gstAmtPerItem;
          acc.gst += gstAmtPerItem * (item.quantity || 0);
          acc.total += totalPerItem * (item.quantity || 0);
          return acc;
        },
        { total: 0, gst: 0 }
      );
      localStorage.setItem('selectedProducts', JSON.stringify(updated));
    },
    setManualQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      if (isNaN(quantity) || quantity < 1) return;
      const updated = state.cartItems.map((item) =>
        item.id === id ? { ...item, quantity } : item
      );
      state.cartItems = updated;
      state.totalItems = updated.reduce((sum, item) => sum + (item.quantity || 0), 0);
      state.totals = updated.reduce(
        (acc, item) => {
          const price = parseFloat(item.base_price || 0);
          const gstRate = parseFloat(item.tax_rate || 0);
          const gstAmtPerItem = (price * gstRate) / 100;
          const totalPerItem = price + gstAmtPerItem;
          acc.gst += gstAmtPerItem * (item.quantity || 0);
          acc.total += totalPerItem * (item.quantity || 0);
          return acc;
        },
        { total: 0, gst: 0 }
      );
      localStorage.setItem('selectedProducts', JSON.stringify(updated));
    },
    resetCart: (state) => {
      state.cartItems = initialState.cartItems;
      state.totals = initialState.totals;
      state.totalItems = initialState.totalItems;
      localStorage.removeItem('selectedProducts');
    },
  },
});

export const {
  setCartItems,
  addToCart,
  updateQuantity,
  removeItem,
  setManualQuantity,
  resetCart,
} = cartSlice.actions;

export default cartSlice.reducer;